import React, {useState} from 'react';
import 'styles/login/SignInputComponent.css';

const SignInputComponent = ({
                                name,
                                viewText,
                                onEnter,
                                onValueChange,
                                error,
                                onKeyPressClearError,
                                value,
                                maxLength,
                                filterRegex,
                            }) => {
    const [internalValue, setInternalValue] = useState('');

    const handleChange = (e) => {
        let newValue = e.target.value;

        if (filterRegex) {
            newValue = newValue.replace(filterRegex, '');
        }

        if (maxLength) {
            newValue = newValue.slice(0, maxLength);
        }

        if (onValueChange) {
            onValueChange(newValue);
        }

        if (value === undefined) {
            setInternalValue(newValue);
        }
    };

    const handleKeyDown = (e) => {
        if (onKeyPressClearError) {
            onKeyPressClearError();
        }

        if (e.key === 'Enter' && onEnter) {
            const current = (value !== undefined) ? value : internalValue;
            onEnter(current);
        }
    };

    const displayedValue = (value !== undefined) ? value : internalValue;

    return (
        <div className="sign-input-container">
            <label className="sign-input-name" htmlFor={name}>
                {viewText}:
            </label>
            <div className="sign-input-inside-container">
                <input
                    type={'text'}
                    id={viewText}
                    autoComplete={name}
                    value={displayedValue}
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    className={'sign-input-inside'}
                />
            </div>
            {error && <p className="sign-input-error">{error}</p>}
        </div>
    );
};

export default SignInputComponent;
